<template>
  <sk-list>
    <sk-list-header
      slot="header"
      class="size-xs font-weight-semi-bold user-list-header"
    >
      <sk-grid-columns>
        <sk-grid-column size="6">{{
          $t('users.info.list_titles.ids')
        }}</sk-grid-column>
        <sk-grid-column size="5">
          {{ $t('users.info.list_titles.activity') }}
        </sk-grid-column>
        <sk-grid-column size="5">
          {{ $t('users.info.list_titles.last_open') }}
        </sk-grid-column>
        <sk-grid-column size="3">
          {{ $t('users.info.list_titles.status') }}
        </sk-grid-column>
        <sk-grid-column size="3">
          {{ $t('users.info.list_titles.permissions') }}
        </sk-grid-column>
        <sk-grid-column size="2">
          {{ $t('users.info.list_titles.action') }}
        </sk-grid-column>
      </sk-grid-columns>
    </sk-list-header>
    <sk-list-items slot="items">
      <sk-list-item
        v-for="(val, index) in users"
        :key="index"
        class="user-list-item size-sm"
      >
        <sk-grid-columns class="user-list-item-content">
          <sk-grid-column size="6" class="size-sm">
            <router-link
              class="user-detail-link color-gray-500"
              :to="{
                name: 'audience-user',
                params: { userId: val.id },
              }"
            >
              <div
                v-if="val.external_id"
                class="color-primary-600 font-weight-semi-bold"
              >
                {{ val.external_id }}
              </div>
              <div v-else class="color-gray-400 font-style-italic">
                No external id
              </div>
              <div class="sentiance-user-id">
                {{ val.id }}
              </div>
            </router-link>
          </sk-grid-column>

          <sk-grid-column size="5" class="color-gray-500">
            <div v-if="val.event_history.length">
              <div class="font-weight-semi-bold color-gray-900 size-sm">
                {{ val.event_history[0].type }}
              </div>
              <div class="font-weight-light size-sm last-event-time">
                @ {{ formatTime(val.event_history[0].start) }}
              </div>
            </div>
            <div v-else class="color-gray-400 font-style-italic">
              No data
            </div>
          </sk-grid-column>
          <sk-grid-column size="5" class="color-gray-400 font-style-italic">
            Coming soon...
          </sk-grid-column>
          <sk-grid-column size="3">
            <sk-badge
              text="Active"
              size="xs"
              weight="semi-bold"
              v-if="val.event_history.length"
            ></sk-badge>
            <sk-badge
              mode="error"
              text="Inactive"
              size="xs"
              weight="semi-bold"
              v-else
            ></sk-badge>
          </sk-grid-column>
          <sk-grid-column size="3" class="color-gray-400 font-style-italic">
            Coming soon...
          </sk-grid-column>
          <sk-grid-column size="2">
            <a href="/graphql" target="_blank"><img :src="icons.graphql"/></a>
          </sk-grid-column>
        </sk-grid-columns>
      </sk-list-item>
    </sk-list-items>
  </sk-list>
</template>

<script>
import { configs } from 'config';
import moment from 'moment';

export default {
  props: {
    users: Array,
  },

  data() {
    const c = configs();

    return {
      icons: {
        graphql: c.IMAGES.GRAPHQL,
      },
    };
  },

  methods: {
    formatTime(value) {
      return moment(value).format('ddd D MMMM YYYY HH:mm:ss.SSS');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

* {
  box-sizing: border-box;
}
</style>
